/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * TikTok browser pixel functions (free tier)
 *
 * Everything the TikTok pixel needs to load and fire browser events. The
 * Events API helpers (user data, page data, cookie validation) live in
 * functions_premium.js.
 * */

(function (pmw, undefined) {

	pmw.loadTikTokPixel = () => {

		try {
			// @formatter:off
			!function (w, d, t) {
				w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};

				ttq.load(pmwDataLayer.pixels.tiktok.pixel_id);
				ttq.page();
			}(window, document, 'ttq');
			// @formatter:on

			// Advanced Matching is a Pro setting and the hashed user data is only
			// in the data layer on Pro, so this block is skipped on free.
			if (
				pmwDataLayer?.pixels?.tiktok?.advanced_matching
				&& (
					pmwDataLayer?.user?.email?.sha256
					|| pmwDataLayer?.user?.phone?.sha256?.e164
				)
			) {
				let identity = {}

				// https://ads.tiktok.com/marketing_api/docs?id=1739585700402178
				if (pmwDataLayer?.user?.email?.sha256) identity.sha256_email = pmwDataLayer.user.email.sha256
				if (pmwDataLayer?.user?.phone?.sha256?.e164) identity.sha256_phone_number = pmwDataLayer.user.phone.sha256.e164

				ttq.identify(identity)
			}

			pmwDataLayer.pixels.tiktok.loaded = true

		} catch (e) {
			console.error(e)
		}
	}

	pmw.getTikTokOrderItemIds = () => {

		let orderItems = []

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			const itemId  = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id ? item.variation_id : item.id
			const product = pmw.getDataLayerProduct(itemId)

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("TikTok: skipped an order item without product data: " + itemId)
				return
			}

			orderItems.push({
				quantity    : item.quantity,
				price       : item.price,
				content_id  : pmw.getProductIdForSpecificPixel(product, "tiktok"),
				content_name: product.name,
			})
		})

		return orderItems
	}

	pmw.tiktokGetPropertiesFromCart = () => {

		let properties = {
			currency    : pmwDataLayer?.shop?.currency,
			value       : 0,
			contents    : [],
			content_type: "product",
		}

		Object.values(pmwDataLayer.cart).forEach((item) => {

			let content = {
				quantity: item.quantity,
				price   : item.price,
			}

			properties.value += item.price * item.quantity

			let dyn_r_ids = (!pmwDataLayer?.shop?.variations_output && item.is_variation && item.id !== 0) ? item.parent_id_dyn_r_ids : item.dyn_r_ids

			content.content_id   = String(dyn_r_ids[pmwDataLayer.pixels.tiktok.dynamic_remarketing.id_type])
			content.content_name = item.name

			properties.contents.push(content)
		})

		return properties
	}

	/**
	 * Check if the TikTok pixel can be fired
	 *
	 * @return {boolean}
	 */
	pmw.canFireTikTokEvent = () => {

		if (!pmwDataLayer?.pixels?.tiktok?.loaded) return false

		// If the user has not given consent for marketing, return false
		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Check if the TikTok pixel can not be fired
	 *
	 * @return {boolean}
	 */
	pmw.canNotFireTikTokEvent = () => {
		return !pmw.canFireTikTokEvent()
	}

}(window.pmw = window.pmw || {}));
